













import { Component, Prop, Vue } from 'vue-property-decorator'

// 收缩展开侧栏菜单
@Component({
  name: 'Hamburger'
})
export default class extends Vue {
  @Prop({ default: false }) private isActive!: boolean

  private toggleClick() {
    this.$emit('toggleClick')
  }
}
